<template>
  <div class="pa-4">
    <h1>aggrid表格demo</h1>
    <p>
      <code>npm install --save ag-grid-enterprise ag-grid-community ag-grid-vue vue-property-decorator@^8.0.0 -w @demo/haha</code>
      <br>
      <code>npm i ag-grid-community@30.1.0 ag-grid-enterprise@30.1.0 ag-grid-vue@30.1.0</code>
      <br>
      <a href="https://www.ag-grid.com/vue-data-grid/">Aggrid 文档</a>
    </p>
    <ag-grid-vue
      style="height: 65vh;"
      class="ag-theme-alpine"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
  </div>
</template>
<script>
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridVue } from "ag-grid-vue";

LicenseManager.setLicenseKey('CompanyName=Suzhou ruhlamat Smart Technologies Co., Ltd.,LicensedApplication=Infinity,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=30,AssetReference=AG-030422,SupportServicesEnd=30_August_2023_[v2]_MTY5MzM1MDAwMDAwMA==28423dd515d527503fc5a257dc86a8ac');

export default {
  name: "Aggrid",
  components: {
    AgGridVue,
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
    };
  },
  beforeMount() {
    this.columnDefs = [
      { field: "make", flex: 1 },
      { field: "model" },
      { field: "price" },
    ];

    this.rowData = [
      { make: "Toyota", model: "Celica", price: 35000 },
      { make: "Ford", model: "Mondeo", price: 32000 },
      { make: "Porsche", model: "Boxster", price: 72000 },
    ];
  },
};
</script>
<style lang="scss" scoped>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";

</style>